import requestTrainingService from "@services/request-training-service";
import { useMutation } from "react-query";

export const useDownloadTrainingRequestMutation = () => {
  return useMutation((id: number) =>
    requestTrainingService.downloadExcelFile(id)
  );
};
